import React from 'react'
import { Col } from 'react-bootstrap'
const MobileInputSubComp = ({children,name,direct,col,mb,mt}) => {
  return (
    <>
        <Col xs={col=="12"?12:col} className={direct=="left"?`pr5`:direct=="center"?``:`pl5`}>
        <div className="basicinput">
            <p>{name}</p>
            <div className="inputgap h35p mbp" style={mb?{marginBottom:mb,marginTop:mt}:{}}>
                {children}
            </div>
        </div>
         </Col>
    </>
  )
}

export default MobileInputSubComp